const formDefaultValues = {
  service_id: '',
  servicePrice_id: '',
  note: '',
  paymentType: ''
};

export default formDefaultValues;
